import {
  HttpContextToken,
  type HttpErrorResponse,
  type HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HotToastService } from '@ngxpert/hot-toast';
import { isStandardError } from '@shared/errors';
import { AuthService } from '@tvd/data-access/auth';
import { EMPTY, catchError, of, retry, throwError } from 'rxjs';

/** List of standard error codes to ignore */
export const IGNORE_ERRORS = new HttpContextToken(() => [] as string[]);

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const toaster = inject(HotToastService);
  const translator = inject(TranslateService);
  const auth = inject(AuthService);
  return next(request).pipe(
    retry({
      count: 1,
      delay: (error, retryCount) => {
        const e = error.error;
        if (isStandardError(e)) {
          if (!e.retryable) {
            return throwError(() => error);
          }
          return of(1000 * retryCount);
        }
        return throwError(() => error);
      },
    }),
    catchError((error: HttpErrorResponse) => {
      const e = error.error;
      if (isStandardError(e)) {
        if (e.code === 'e00271') {
          auth.logout();
        }
        const ignoredErrors = request.context.get(IGNORE_ERRORS);
        if (!ignoredErrors?.length || !ignoredErrors.includes(e.code)) {
          toaster.error(translator.instant(`enum.error.${e.code}`), {
            duration: 4000,
            id: e.code,
          });
        }
      }
      if (error.url?.includes('posthog.com')) {
        return EMPTY;
      }

      return throwError(() => error);
    }),
  );
};
